export const construyeTuCaminoCards = [
    {
        "urlCtc" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/interes/CTC/BasesCTC.pdf",
        "urlName" : "Bases de Convocatoria",
        "icoName" : "icon-call-bases"
    },
    {
        "urlCtc" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/interes/CTC/ReglasOperacionCTC.pdf",
        "urlName" : "Reglas de Operación",
        "icoName" : "icon-operating-rules"
    },
    {
        "urlCtc" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/interes/CTC/AnexosCTC.pdf",
        "urlName" : "Anexos",
        "icoName" : "icon-documentation"
    }
]